const password = (value) => value.length >= 6;
export default password;
